/**
 * * This file is responsible for handling the accordion with nav functionality, which includes:
 * * - Placing the nav bar in the right place and with the right styles when the user scrolls to the footer
 * * - Listening for clicks on the nav bar and accordions, and updating the state accordingly
 * * - Active the accordion through URL when the page loads with a specific module query parameter
 * * - Handling the accordion opening and closing based on scroll position (currently commented out)
 * 
 * * The state of the accordion is managed through a Proxy object, which allows us to react to changes in the state and update the UI accordingly.
 * 
 * ! If looking for the code related to the accordion with filter, please check the file accordion-filter.js
 */
const stateAccordion = {
    idToActive: null,
    activeElementsFrom: null
};

const observeState = new Proxy(stateAccordion, {
    set(collection, key, newValue) {

        // console.log(`The property/key "${key}" changed from "${collection[key]}" to "${newValue}"`);
        collection[key] = newValue;
        updateAccordionAndNav();
        return true;

    }
});

function updateAccordionAndNav(){
    
    const CURRENT_NAV_ELE_ACTIVE = document.querySelector(`.js-accordionWithNav_tabs a.active`);
    const ALL_NAV_ELEMENTS = document.querySelectorAll(`.js-accordionWithNav_tabs a`);

    if( CURRENT_NAV_ELE_ACTIVE )
        CURRENT_NAV_ELE_ACTIVE.classList.remove(`active`)

    ALL_NAV_ELEMENTS.forEach( nav_ele => {
        if( nav_ele.dataset.value == stateAccordion.idToActive  ){
            nav_ele.classList.add(`active`);
            if( stateAccordion.activeElementsFrom == 'nav' ){
                window.history.pushState({}, ``, `?` + `module=${nav_ele.dataset.value}`);
                setTimeout(() => {
                    scrollFunctionality();
                }, 500);
            }else{
                window.history.pushState({}, ``, `?`);
            }
        }
    } );
    
    const ALL_ACCORDIONs_ACTIVE = document.querySelectorAll(`.js-eachAccordion.opened`);
    const ALL_ACCORDIONs = document.querySelectorAll(`.js-eachAccordion`);

    if( ALL_ACCORDIONs_ACTIVE.length > 0 && stateAccordion.activeElementsFrom == 'nav' ){
        ALL_ACCORDIONs_ACTIVE.forEach( activeAccordion => {
            activeAccordion.classList.remove(`opened`);
            activeAccordion.querySelector(`.js-elementToExpand`).removeAttribute(`style`);
        } )

    }

    ALL_ACCORDIONs.forEach( accordion => {
        if( accordion.id == stateAccordion.idToActive ){
            let elementToExpand = accordion.querySelector(`.js-elementToExpand`);
            
            if( stateAccordion.activeElementsFrom == 'nav' ){
                accordion.classList.add(`opened`);
                setTimeout(() => {
                    let heightForExpandEle = accordion.querySelector(`.js-elementToCalcHeight`).getBoundingClientRect().height;
                    elementToExpand.setAttribute(`style`, `height:${heightForExpandEle}px`);
                }, 250);
            }else{
                accordion.classList.toggle(`opened`);
                if( accordion.classList.contains(`opened`) )
                    setTimeout(() => {
                        let heightForExpandEle = accordion.querySelector(`.js-elementToCalcHeight`).getBoundingClientRect().height;
                        elementToExpand.setAttribute(`style`, `height:${heightForExpandEle}px`);
                    }, 250);
                else
                    elementToExpand.removeAttribute(`style`);
            }
        }
    } );
}

function placementAccordionNavBar() {
    const OBSERVER = new IntersectionObserver(callback);
    const FOOTER = document.querySelector(`footer`);
    const NAV_ACCORDION = document.querySelector(`.js-accordionWithNav_tabs`);

    function callback( elements, OBSERVER ){
        elements.forEach( singleEle => {
            if(singleEle.isIntersecting)
                NAV_ACCORDION.classList.add('arriveToFooter');
            else
                NAV_ACCORDION.classList.remove('arriveToFooter');
    } );
    }

    OBSERVER.observe(FOOTER);

}

function listenAccordionAndNav(){
    const ALL_NAVs = document.querySelectorAll(`.js-accordionWithNav_tabs`);
    const ALL_ACCORDIONs = document.querySelectorAll(`.js-eachAccordion`);

    ALL_NAVs.forEach( nav => {
        nav.addEventListener( 'click', event => {
            let elementClicked = event.target;
            if( elementClicked.nodeName == 'A' ){
                event.preventDefault();
                let value = elementClicked.dataset.value;
                stateAccordion.activeElementsFrom = 'nav';
                observeState.idToActive = value;
            }
        } );
    } );

    ALL_ACCORDIONs.forEach( accordion => {
        const TRIGGER_ACCORDION = accordion.querySelector(`.js-triggerAccordion`);
        TRIGGER_ACCORDION.addEventListener( 'click', event => {
            let value = accordion.id;
            stateAccordion.activeElementsFrom = 'accordion';
            observeState.idToActive = value;
        } )
    } );
}

function activeAccordionThroughURL(){
    let identifier = currentUrl.searchParams.get('module');
    let navElement = document.querySelector(`a[data-value="${identifier}"]`);
    navElement.click();
}

function handleAccordionsByScroll(){
    const OPTIONS = {
        threshold: 1,
        rootMargin: "-30% 0px -35% 0px"
    }
    const OBSERVER = new IntersectionObserver(callback, OPTIONS);
    const ALL_ACCORDIONs = document.querySelectorAll(`.js-eachAccordion`);
    let beforeElement = null;

    function callback( elements, OBSERVER ){
        elements.forEach( singleEle => {
            if( window.location.href.indexOf('module=') == -1 ){
                if( singleEle.isIntersecting ){
                    if( beforeElement != singleEle.target){
                        singleEle.target.querySelector(`.js-triggerAccordion`).click();
                    }
                    beforeElement = singleEle.target;
                }
                // else if( !singleEle.isIntersecting && singleEle.target.getBoundingClientRect().y < 0 ){
                //     singleEle.target.querySelector(`.js-triggerAccordion`).click();
                // }
            }
        } );
    }

    ALL_ACCORDIONs.forEach( accordion => OBSERVER.observe(accordion) )
}

function manageAccordionFunctions(){

    placementAccordionNavBar();
    listenAccordionAndNav();
    //handleAccordionsByScroll();
    
    if( currentUrl.searchParams.get('module') )
        activeAccordionThroughURL();

}

document.addEventListener('DOMContentLoaded', () => {
     if( document.querySelector(`.js-accordionWithNav`) ){
        setTimeout(() => {
            manageAccordionFunctions();
        }, 500);
    }
});